/* eslint-disable no-shadow */
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiGetRoomDid } from '../../utils/api';
import { capitalize, capitalizeFirst, createRoomName } from '../../utils';

// returns current location object
export function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

// sets the state for all information associated with the name of the user
export default function useNameDomain() {
  let queryParams = useQueryParams();
  const [domain, setDomain] = useState<string>('');
  const [roomName, setRoomName] = useState<string>('');
  const [username, setUsername] = useState<string>('');
  const [roomOwnerUsername, setRoomOwnerUsername] = useState<string>('');
  const [roomOwnerDomain, setRoomOwnerDomain] = useState<string>('');
  const [ownRoomDid, setOwnRoomDid] = useState<number | null>();
  const [password, setPassword] = useState<string | null>('');
  const [userToCall, setUserToCall] = useState<string | null>('');
  const [userToInvite, setUserToInvite] = useState<string | null>('');
  const [meetingCreated, setMeetingCreated] = useState(false);
  const [isUsernameInUrl, setIsUsernameInUrl] = useState(false);

  const { pathname } = useLocation();

  // grabs strings that are needed
  useEffect(() => {
    const queryUsername: string = capitalize(queryParams.get('username')) || '';
    const queryDomain = capitalize(queryParams.get('domain'));
    const queryRoomname = capitalizeFirst(queryParams.get('room')) || createRoomName(queryUsername, queryDomain);
    const queryRoomOwnerUsername = capitalize(queryParams.get('roomusername')) || '';
    const queryRoomOwnerDomain = capitalize(queryParams.get('roomdomain')) || '';
    const cookiePassword = decodeURIComponent(getCookie('password'));
    const queryPassword = queryParams.get('password');
    const queryUserToCall = queryParams.get('calltouser');
    const queryUserToInvite = queryParams.get('inviteuser');

    // fetches RoomDID
    if (queryUsername && queryDomain && pathname !== '/voice') {
      apiGetRoomDid(queryUsername, queryDomain).then(roomDid => setOwnRoomDid(roomDid));
    }
    setPassword(cookiePassword || queryPassword);
    setDomain(queryDomain);
    setUsername(queryUsername);
    setIsUsernameInUrl(!!queryUsername);
    setRoomName(queryRoomname);
    setRoomOwnerUsername(queryRoomOwnerUsername);
    setRoomOwnerDomain(queryRoomOwnerDomain);
    setUserToCall(queryUserToCall);
    setUserToInvite(queryUserToInvite);

    //@ts-ignore
    window.getUserToInvite = (_username: string) => {
      setUserToInvite(_username);
    };
  }, []);

  useEffect(() => {
    if (meetingCreated) {
      setTimeout(() => {
        setMeetingCreated(false);
      }, 3000);
    }
  }, [meetingCreated]);

  return {
    username,
    domain,
    roomName,
    setUsername,
    setRoomName,
    roomOwnerUsername,
    roomOwnerDomain,
    isUsernameInUrl,
    ownRoomDid,
    password,
    userToCall,
    userToInvite,
    meetingCreated,
    setMeetingCreated,
  };
}

export const getCookie = (name: string): string => {
  const cookies = document.cookie.split(';');
  const requiredCookie = cookies.find(cookie => cookie.split('=')[0].trim() === name);
  return requiredCookie ? requiredCookie.split('=')[1] : '';
};
